// src/Redux/packingListSlice.ts
import { createSlice } from '@reduxjs/toolkit';

export const packingListSlice = createSlice({
  name: 'packingList',
  initialState: {
    account: null,
    name: '',
    logo_url: '',
    signature_url: '',
  },
  reducers: {
    setPackingList: (state, action) => {
      state.account = action.payload.account;
      state.name = action.payload.name;
      state.logo_url = action.payload.logo_url;
      state.signature_url = action.payload.signature_url;
    },
  },
});

export const { setPackingList } = packingListSlice.actions;
export default packingListSlice.reducer;
